function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16c0 6.351-5.149 11.5-11.5 11.5S4.5 22.351 4.5 16 9.649 4.5 16 4.5 27.5 9.649 27.5 16Zm2.5 0c0-7.732-6.268-14-14-14S2 8.268 2 16s6.268 14 14 14 14-6.268 14-14Zm-18.667 2.738a1.333 1.333 0 0 0-1.192 1.93l.001.002.001.003.003.006.008.015a3.451 3.451 0 0 0 .094.169c.06.101.146.237.258.396A6.8 6.8 0 0 0 11.53 22.4c.942.837 2.412 1.67 4.469 1.67 2.057 0 3.527-.833 4.47-1.67a6.8 6.8 0 0 0 1.024-1.142 5.668 5.668 0 0 0 .352-.565l.008-.015.003-.006.001-.003v-.001l.001-.002a1.333 1.333 0 0 0-1.192-1.93h-9.334Zm9.334-7.6a1.6 1.6 0 0 1 1.6 1.6v.8a1.6 1.6 0 0 1-3.2 0v-.8a1.6 1.6 0 0 1 1.6-1.6Zm-7.734 1.6a1.6 1.6 0 0 0-3.2 0v.8a1.6 1.6 0 1 0 3.2 0v-.8Z"
  }));
};
var componentName = 'SmileOutlined';
export var SmileOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
SmileOutlined.displayName = componentName;